import { useSlate } from 'slate-react';
import { twMerge } from 'tailwind-merge';
import { Tooltip } from 'ui';
import { IconButton } from 'ui/atoms';

import { isCodeBlockActive, toggleCodeBlock } from '../utils';

type InsertCodeButtonProps = {
  icon: JSX.Element;
  title: string;
  withTitle?: boolean;
};

const InsertCodeButton = ({ icon, title, withTitle }: InsertCodeButtonProps) => {
  const editor = useSlate();

  return (
    <Tooltip title={withTitle ? '' : title} placement="top">
      <IconButton
        className={twMerge(
          'flex items-center justify-center w-9 h-9 hover:bg-transparent active:bg-v2blueGray-100',
          isCodeBlockActive(editor) && 'bg-v2blueGray-100 hover:bg-v2blueGray-100',
        )}
        onMouseDown={(event) => {
          event.preventDefault();
          toggleCodeBlock(editor);
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export { InsertCodeButton };
